module.exports = __webpack_public_path__ + "static/media/glass-whiskey.8c3db494.svg";